import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ManageSubscription = Loadable(
  lazy(() =>
    import("./manageSubscription").then(({ ManageSubscription }) => ({
      default: ManageSubscription,
    }))
  )
);

const SubscriptionLimitPage = Loadable(
  lazy(() =>
    import("./SubscriptionLimitPage").then(({ SubscriptionLimitPage }) => ({
      default: SubscriptionLimitPage,
    }))
  )
);

export const SubscriptionRoutes = [
  {
    path: "/subscription",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SUBSCRIPTION]}>
        <ManageSubscription />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/subscription/limit",
    exact: true,
    element: <SubscriptionLimitPage />,
  },
];
